

import React, { memo, useMemo } from 'react';
import cx from 'classnames';

import { getDataTableCellContentStyleModifiers } from '../utils/factories/dataTableCellStyleFactory';
import '../styles/_data-table-cell.scss';









const DataTableCell = (props) => {
  const {
    className,
    column,
    colSpan,
    children,
    isBold,
    isNoWrap,
    customClassName,
    fontSizeType = ''
  } = props;

  const contentStyleModifiers = useMemo(
    () => getDataTableCellContentStyleModifiers(column), [column]
  );

  return (
    <td
      className={
      cx('data-table-cell', className, customClassName, {
        'data-table-cell--no-wrap': isNoWrap,
        'data-table-cell--bold': isBold,
        [`data-table-cell--font-size-${fontSizeType}`]: fontSizeType
      })}

      colSpan={colSpan}
      data-column-field={column.field}>

      <div className={
      cx('data-table-cell__content', {
        [`data-table-cell__content--${contentStyleModifiers.alignHorizontal}`]: contentStyleModifiers.alignHorizontal
      })}>

        {children}
      </div>
    </td>);

};

export default memo(DataTableCell);